import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M17 6.5L12 12L17 17.5M11 6.5L6 12L11 17.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
